import { Controller } from '@hotwired/stimulus';

let pointerFineMatchMedia;

const isMouse = () => {
  pointerFineMatchMedia ||= window.matchMedia('(pointer: fine)');

  return pointerFineMatchMedia.matches;
};

export default class extends Controller {
  static targets = ['button', 'content'];

  handleMouseEnter() {
    if (!isMouse()) return;

    this.contentTarget.showPopover();
  }

  handleMouseLeave() {
    if (!isMouse()) return;

    this.contentTarget.hidePopover();
  }

  handleBeforeToggle(event) {
    if (event.newState === 'open') {
      this.contentTarget.style.visibility = 'hidden';
    }
  }

  handleToggle(event) {
    if (event.newState === 'open') {
      this.contentTarget.style.visibility = '';
      this.positionTooltip();
    }
  }

  positionTooltip() {
    const button = this.buttonTarget;
    const content = this.contentTarget;
    const isOpen = content.matches(':popover-open');

    if (!isOpen) return;

    const buttonRect = button.getBoundingClientRect();
    const contentRect = content.getBoundingClientRect();
    const container = button.closest('[data-campaigns-statistic]');
    const top = container.querySelector('[data-campaigns-statistic-top]');
    const topRect = top.getBoundingClientRect();
    const buttonCenter = buttonRect.left + buttonRect.width / 2;
    const left = (() => {
      let calc = buttonCenter - contentRect.width / 2;
      if (calc < topRect.left) {
        calc = topRect.left;
      }
      if (calc + contentRect.width > topRect.right) {
        calc = topRect.right - contentRect.width;
      }
      return calc;
    })();
    const contentCenter = left + contentRect.width / 2;
    const contentCenterToButtonCenter = buttonCenter - contentCenter;
    content.style.bottom = `calc(100vh - ${buttonRect.bottom + contentRect.height + 7}px)`;
    content.style.setProperty('--left', `${left}px`);
    content.style.setProperty('--width', `${topRect.width}px`);
    content.style.setProperty('--triangle-adjustment', `${contentCenterToButtonCenter}px`);

    window.requestAnimationFrame(() => this.positionTooltip());
  }
}
